import React, { useState, useEffect } from "react";
import { UrlApi } from "../../../services/apirest";
import {
  Container,
  Autocomplete,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Box,
  TextField,
  IconButton,
  Button,
  InputAdornment,
  Typography,
  Chip,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AccessibilityNewIcon from "@mui/icons-material/AccessibilityNew";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import InsertInvitationIcon from "@mui/icons-material/InsertInvitation";
import { grey } from "@mui/material/colors";
import PinIcon from "@mui/icons-material/Pin";
import moment from "moment";
import Notify from "../../Notify";
import { getData, getCodeArg, putData } from "../../../services/library";
import { empresasConfig } from "../../envasados/sucursalesMercadoLibre/config";

function Editarchofer(props) {
  const [datosformulario, setDatosformulario] = useState(props.datos);
  const [negocio, setnegocio] = useState(null);
  const [usuarios, setUsuarios] = useState(null);
  const [disBtn, setDisBtn] = useState(false);
  const [ptosVtaHiper, setPtosVtaHiper] = useState();
  const [ptosVtaAuto, setPtosVtaAuto] = useState();
  const [codArg, setCodArg] = useState("");
// Estados para Sucursal y Caja
const [sucursales, setSucursales] = useState([]);
const [sucursalSeleccionada, setSucursalSeleccionada] = useState(null);
const [cajasMercadoPago, setCajasMercadoPago] = useState([]);
const [cajaSeleccionada, setCajaSeleccionada] = useState(null);
const [cargandoCajas, setCargandoCajas] = useState(false);
  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });
// Agregar después de los otros estados
const [posnets, setPosnets] = useState([]);
const [posnetSeleccionado, setPosnetSeleccionado] = useState(null);
const [errorTerminal, setErrorTerminal] = useState("");

  const cargarSucursales = async () => {
  try {
    const response = await fetch(`${UrlApi}/sucursales/`);
    const data = await response.json();
    setSucursales(Array.isArray(data) ? data : []);
  } catch (error) {
    console.error("Error al cargar sucursales:", error);
  }
};

// Cargar cajas por sucursal
const cargarCajasPorSucursal = async (sucursalId) => {
  if (!sucursalId) {
    setCajasMercadoPago([]);
    return;
  }
  
  setCargandoCajas(true);
  try {
    const id = typeof sucursalId === 'object' ? sucursalId.id : sucursalId;
    const response = await fetch(`${UrlApi}/envasado_cajas_mercadolibre/xsucursalnetizaredit/${id}/${datosformulario.id}`);
    const data = await response.json();
    
    const cajasArray = Array.isArray(data) ? data : (data.results || data.data || []);
    setCajasMercadoPago(cajasArray);
    
    // Si hay una caja guardada previamente, seleccionarla
    if (datosformulario.id_caja_mp && cajasArray.length > 0) {
      const cajaGuardada = cajasArray.find(c => c.id === datosformulario.id_caja_mp);
      if (cajaGuardada) {
        setCajaSeleccionada(cajaGuardada);
      }
    }
  } catch (error) {
    console.error('Error al cargar cajas:', error);
    setCajasMercadoPago([]);
  } finally {
    setCargandoCajas(false);
  }
};

// Agregar después de cargarCajasPorSucursal
const cargarPosnets = async (sucursal) => {
  if (!sucursal) {
    setPosnets([]);
    setPosnetSeleccionado(null);
    return;
  }

  let empresa = sucursal?.empresa || null;
  console.log("SUCURSAL", empresa);
  
  try {
    let url = empresa === 1 
      ? empresasConfig.hipergas.apiBaseUrl 
      : empresasConfig.naturalgas.apiBaseUrl;
    
    const response = await fetch(`${url}/api/qr/mp/terminals`);
    const data = await response.json();
    
    // Obtener los resultados
    let terminales = [];
    if (data.results) {
      terminales = data.results;
    } else if (data.data && data.data.terminals) {
      terminales = data.data.terminals;
    } else if (Array.isArray(data)) {
      terminales = data;
    }
    
    // Filtrar solo los que están en modo PDV
    const terminalesPDV = terminales.filter(t => t.operating_mode === "PDV");
    setPosnets(terminalesPDV);
    
    // Si hay una terminal guardada previamente, seleccionarla
    if (datosformulario.posnet && terminalesPDV.length > 0) {
      const terminalGuardada = terminalesPDV.find(t => t.id === datosformulario.posnet);
      if (terminalGuardada) {
        setPosnetSeleccionado(terminalGuardada);
      }
    }
    
    console.log("Terminales PDV:", terminalesPDV);
    
  } catch (error) {
    console.error('Error al cargar posnets:', error);
    setPosnets([]);
  }
};

useEffect(() => {
  cargarSucursales();
}, []);
// useEffect(() => {
//   if (sucursalSeleccionada) {
//     const sucursalId = sucursalSeleccionada.id;
//     cargarCajasPorSucursal(sucursalId);
//   } else {
//     setCajasMercadoPago([]);
//     setCajaSeleccionada(null);
//   }
// }, [sucursalSeleccionada]);
// Modificar el useEffect existente
useEffect(() => {
  if (sucursalSeleccionada) {
    const sucursalId = sucursalSeleccionada.id;
    cargarCajasPorSucursal(sucursalId);
    cargarPosnets(sucursalSeleccionada); // Agregar esta línea
  } else {
    setCajasMercadoPago([]);
    setCajaSeleccionada(null);
    setPosnets([]);
    setPosnetSeleccionado(null);
    setErrorTerminal("");
  }
}, [sucursalSeleccionada]);

  useEffect(() => {
    setDatosformulario({
      ...props.datos,
      telefono: props.datos.telefono
        ? props.datos.telefono.replace(/^(\+?549)?(\d{10})$/, "$2")
        : "",
    });
  }, [props.datos]);

useEffect(() => {
  // Cargar sucursal guardada
  if (datosformulario.id_sucursal && sucursales.length > 0) {
    const sucursalGuardada = sucursales.find(s => s.id === datosformulario.id_sucursal);
    if (sucursalGuardada) {
      setSucursalSeleccionada(sucursalGuardada);
    }
  }
}, [sucursales]);
console.log(datosformulario);

useEffect(() => {
  // Cargar caja guardada (por nombre)
  if (datosformulario.caja_mercadolibre && cajasMercadoPago.length > 0) {
    const cajaGuardada = cajasMercadoPago.find(c => c.nombre === datosformulario.caja_mercadolibre || c.external_id === datosformulario.caja_mercadolibre);
    if (cajaGuardada) {
      setCajaSeleccionada(cajaGuardada);
    }
  }
}, [cajasMercadoPago]);

  const obtenerPtosVtaHiperYAuto = async () => {
    try {
      const [hiperResponse, autoResponse] = await Promise.all([
        fetch(
          UrlApi +
            "/puntos_venta/autocompleteed/1/" +
            props.datos.pto_vta_hipergas
        ),
        fetch(
          UrlApi +
            "/puntos_venta/autocompleteed/4/" +
            props.datos.pto_vta_autogas
        ),
      ]);

      if (!hiperResponse.ok || !autoResponse.ok) {
        throw new Error("Error en la respuesta de la API");
      }

      const hiperData = await hiperResponse.json();
      const autoData = await autoResponse.json();

      if (Array.isArray(hiperData) && Array.isArray(autoData)) {
        setPtosVtaHiper(hiperData);
        setPtosVtaAuto(autoData);

        setDatosformulario((prevState) => ({
          ...prevState,
          pto_vta_hipergas:
            hiperData.find(
              (pto) => parseInt(pto.id_punto) === prevState.pto_vta_hipergas
            ) || null,
          pto_vta_autogas:
            autoData.find(
              (pto) => parseInt(pto.id_punto) === prevState.pto_vta_autogas
            ) || null,
        }));
      } else {
        console.error("Error: Los datos de puntos de venta no son válidos");
      }
    } catch (error) {
      console.error("Error al obtener puntos de venta:", error);
    }
  };

  useEffect(() => {
    obtenerPtosVtaHiperYAuto();
    getData("/desplegables/usoVehiculo", setnegocio);
    getData(
      "/choferes/xusernameypuesto/" + datosformulario.username,
      setUsuarios
    );
    getCodeArg(setCodArg);
  }, []);

  const handleClose = () => {
    props.editar(false);
    props.tabla(true);
    props.actualizar(1);
  };

  // console.log(datosformulario?.pto_vta_autogas?.id_punto)
  // console.log(datosformulario?.pto_vta_hipergas?.id_punto)

  async function guardarChofer(e) {
    e.preventDefault();
    setDisBtn(true);
    putData(
      e,
      "/choferes/updatechofyptovta/" + datosformulario.id,
      {
        reqBody: {
          id_sucursal:sucursalSeleccionada?.id??null,
          caja_mercadolibre:cajaSeleccionada?.external_id??null,
          posnet: posnetSeleccionado?.id ?? null, 
          id_sisven: datosformulario.id_sisven,
          id_sisven_autogas:datosformulario.id_sisven_autogas,
          nombre_apellido: datosformulario.nombre_apellido,
          dni: datosformulario.dni,
          usuario: localStorage.getItem("user"),
          legajo: datosformulario.legajo,
          nro_licencia: datosformulario.nro_licencia,
          vencimiento_licencia:
            datosformulario.vencimiento_licencia !== ""
              ? datosformulario.vencimiento_licencia
              : null,
          examen_carga:
            datosformulario.examen_carga !== ""
              ? datosformulario.examen_carga
              : null,
          negocio: datosformulario.negocio,
          username: datosformulario.username,
          telefono: datosformulario.telefono
            ? codArg + datosformulario.telefono
            : null,
          pto_vta_autogas:
            parseInt(datosformulario?.pto_vta_autogas?.id_punto) || null,
          pto_vta_hipergas:
            parseInt(datosformulario?.pto_vta_hipergas?.id_punto) || null,

        fecvto_art:datosformulario.fecvto_art !== "" ? datosformulario.fecvto_art : null,
       fecvto_svo:datosformulario.fecvto_svo !== "" ? datosformulario.fecvto_svo : null,
      //  fecvto_remito:datosformulario.fecvto_remito !== "" ? datosformulario.fecvto_remito : null,
      //  fecvto_protcal:datosformulario.fecvto_protcal !== "" ? datosformulario.fecvto_protcal : null,
       fecvto_cursocp:datosformulario.fecvto_cursocp !== "" ? datosformulario.fecvto_cursocp : null,
       fecvto_psicof:datosformulario.fecvto_psicof !== "" ? datosformulario.fecvto_psicof : null,
        },
        ptos_anteriores: {
          pto_anterior_hiper: props.datos.pto_vta_hipergas,
          pto_anterior_auto: props.datos.pto_vta_autogas,
        },
      },
      setNotificacion
    );
  }

  //funcion para almacenar
  const almacenar = (e) => {
    const { name, value } = e.target;
    setDatosformulario((prev) => ({
      ...prev,
      [name]: value === "" ? null : value,
    }));
  };

  const style = {
    backgroundColor: "#ffffff",
    width: "100%",
  };

  const size = "small";
  const sinAsterisco = {
    "& .MuiFormLabel-asterisk": { display: "none" },
  };

  //en edicion tendria que excluir el id que se esta editando o no ponerlo
  
  // función para validar DNI
  // const validarDni = async (dni) => {
  //   try {
  //     const res = await fetch(`${UrlApi}/choferes/existedni/${dni}`);
  //     const data = await res.json();
  
  //      if (data.length > 0) {
  //       setErrorDni("Ya existe un chofer con ese DNI");
  //       setDisBtn(true)
  //     } else {
  //       setErrorDni(""); // limpia si es válido
  //       setDisBtn(false)
  //     }
  //   } catch (err) {
  //     console.error("Error al verificar existencia del DNI:", err);
  //     setErrorDni("Error al validar DNI");
  //   }
  // };
  
  // const validarCampo = async (campo, valor) => {
  //   try {
  //     let url = "";
  
  //     // Definir el endpoint según el campo
  //     switch(campo) {
  //       case "dni":
  //         url = `${UrlApi}/choferes/existedni/${valor}`;
  //         break;
  //       case "nro_licencia":
  //         url = `${UrlApi}/choferes/existenrolicencia/${valor}`;
  //         break;
  //       default:
  //         return; // si el campo no es válido, salir
  //     }
  
  //     // Hacer la consulta al backend
  //     const res = await fetch(url);
  //     const data = await res.json();
  
  //     // Manejar los errores y habilitar/deshabilitar botón
  //     if (data.length > 0) {
  //       if (campo === "dni") setErrorDni("Ya existe un chofer con ese DNI");
  //       if (campo === "nro_licencia") setErrorNroLicencia("Ya existe un chofer con esa licencia");
  //       setDisBtn(true);
  //     } else {
  //       if (campo === "dni") setErrorDni("");
  //       if (campo === "nro_licencia") setErrorNroLicencia("");
  //       setDisBtn(false);
  //     }
  
  //   } catch (err) {
  //     console.error(`Error al verificar ${campo}:`, err);
  //     if (campo === "dni") setErrorDni("Error al validar DNI");
  //     if (campo === "nro_licencia") setErrorNroLicencia("Error al validar número de licencia");
  //   }
  // };

  // Agregar después de las otras funciones
const validarCampo = async (campo, valor) => {
  try {
    let url = "";

    switch(campo) {
      case "terminal":
        url = `${UrlApi}/choferes/terminalusada/${valor}`;
        break;
      default:
        return;
    }

    const res = await fetch(url);
    const data = await res.json();

    if (data.length > 0) {
      if (campo === "terminal") {
        const nombreChofer = data?.[0]?.nombre_apellido || "desconocido";
        setErrorTerminal(`Esta terminal ya está asignada al chofer: ${nombreChofer}`);
        setDisBtn(true)
      }
    } else {
      if (campo === "terminal") {
        setErrorTerminal("");
        setDisBtn(false)
      }
    }

  } catch (err) {
    console.error(`Error al verificar ${campo}:`, err);
    if (campo === "terminal") {
      setErrorTerminal("Error al validar terminal");
    }
  }
};

  return (
    <div>
      <br></br>
      <Container>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container backgroundColor="#1F618D" p={1.5}>
            <Grid item xs={2}>
              <IconButton onClick={handleClose}>
                <ArrowBackIcon sx={{ color: grey[50] }} />
              </IconButton>
            </Grid>

            <Grid
              item
              xs={8}
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
            >
              <Typography variant="h5" color="#ffffff">
                Editar chofer
              </Typography>
            </Grid>
          </Grid>
        </Box>
        <form onSubmit={guardarChofer} autoComplete="off">
          <Box
            backgroundColor="#F4F6F6"
            mt={2}
            p={3}
            border={0.5}
            borderColor={"#ABB2B9"}
            borderRadius={4}
          >
            <Grid container spacing={1} direction={{ xs: "column", sm: "row" }}>
              <Grid item xs={6}>
                <TextField
                  size={size}
                  placeholder="Nombre completo"
                  style={style}
                  focused
                  color="primary"
                  required
                  name="nombre_apellido"
                  label="Nombre completo"
                  variant="outlined"
                  value={
                    datosformulario.nombre_apellido &&
                    datosformulario.nombre_apellido.replace(/\b\w/g, (l) =>
                      l.toUpperCase()
                    )
                  }
                  inputProps={{ maxLength: 100 }}
                  onChange={almacenar}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AccessibilityNewIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              <Grid item xs={3}>
                <TextField
                  size={size}
                  style={style}
                  sx={sinAsterisco}
                  focused
                  color="primary"
                  placeholder="ID de Sisven HIPERGAS"
                  type="number"
                  name="id_sisven"
                  label="ID SISVEN HIPERGAS"
                  variant="outlined"
                  value={datosformulario.id_sisven ?? ""}
                  onChange={almacenar}
                  inputProps={{ min: 0 }} // para manejar numeros negativos
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AccountBoxIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  size={size}
                  style={style}
                  sx={sinAsterisco}
                  focused
                  color="primary"
                  placeholder="ID de Sisven AUTOGAS"
                  type="number"
                  name="id_sisven_autogas"
                  label="ID SISVEN AUTOGAS"
                  variant="outlined"
                  value={datosformulario.id_sisven_autogas ?? ""}
                  onChange={almacenar}
                  inputProps={{ min: 0 }} // para manejar numeros negativos
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AccountBoxIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  size={size}
                  focused
                  placeholder="DNI"
                  color="primary"
                  style={style}
                  sx={sinAsterisco}
                  type="text"
                  name="dni"
                  label="DNI"
                  variant="outlined"
                  value={datosformulario.dni ?? ""}
                  onChange={almacenar}
                //  onBlur={() => {
                //     if (datosformulario.dni) {
                // validarCampo("dni", datosformulario.dni);
                //     }
                //   }}
                 inputProps={{ maxLength: 8,min: 0 }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AccountCircleIcon />
                      </InputAdornment>
                    ),
                  }}
                  //   error={Boolean(errorDni)}    // activa rojo si hay error
                  // helperText={errorDni} // muestra error o ayuda normal
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  size={size}
                  style={style}
                  focused
                  placeholder="Legajo"
                  type="number"
                  name="legajo"
                  label="Legajo"
                  variant="outlined"
                  value={datosformulario.legajo}
                  onChange={almacenar}
                  inputProps={{ maxLength: 45, min: 0 }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AccountCircleIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  size={size}
                  style={style}
                  sx={sinAsterisco}
                  focused
                  placeholder="Nro licencia"
                  type="text"
                  name="nro_licencia"
                  label="Nro licencia"
                  variant="outlined"
                  value={datosformulario.nro_licencia ?? ""}
                  onChange={almacenar}
                  // onBlur={() => {
                  // if (datosformulario.nro_licencia) {
                  //  validarCampo("nro_licencia", datosformulario.nro_licencia);
                  //   }
                  // }}
                  inputProps={{ maxLength: 8,min: 0 }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PinIcon />
                      </InputAdornment>
                    ),
                  }}
                  //     error={Boolean(ErrorNroLicencia)}    // activa rojo si hay error
                  // helperText={ErrorNroLicencia} // muestra error o ayuda normal
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  size={size}
                  style={style}
                  focused
                  type="date"
                  placeholder="Vencimiento licencia"
                  name="vencimiento_licencia"
                  label="Vencimiento licencia"
                  variant="outlined"
                  value={datosformulario.vencimiento_licencia ? moment(datosformulario.vencimiento_licencia).format("YYYY-MM-DD") : ""}
                  onChange={almacenar}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <InsertInvitationIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  size={size}
                  style={style}
                  focused
                  type="date"
                  placeholder="Exámen cargas"
                  name="examen_carga"
                  label="Examen cargas"
                  variant="outlined"
                  value={datosformulario.examen_carga ? moment(datosformulario.examen_carga).format("YYYY-MM-DD") : ""}
                  onChange={almacenar}
                />
              </Grid>

              <Grid item xs={6}>
                <FormControl
                  style={style}
                  size={size}
                  focused
                  color="primary"
                  required
                >
                  <InputLabel id="lbl_negocio">Negocio</InputLabel>
                  <Select
                    name="negocio"
                    label="Negocio "
                    value={datosformulario.negocio}
                    onChange={almacenar}
                  >
                    {negocio
                      ? negocio.map((elemento) => (
                          <MenuItem key={elemento.id} value={elemento.id}>
                            {elemento.valor}
                          </MenuItem>
                        ))
                      : null}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6}>
               <Autocomplete
                               size={size}
                               options={usuarios || []}
                               getOptionLabel={(option) =>
                                 option.nombrepila && option.apellido
                                   ? `${option.nombrepila} ${option.apellido} (${option.username})`
                                   : option.username || ""
                               }
                               value={
                                 usuarios?.find((b) => b.username === datosformulario.username) || null
                               }
                               onChange={(_, newValue) => {
                                 setDatosformulario((prev) => ({
                                   ...prev,
                                   username: newValue ? newValue.username : null,
                                 }));
                               }}
                               isOptionEqualToValue={(option, value) =>
                                 option.username === value.username
                               }
                               renderInput={(params) => (
                                 <TextField
                                   {...params}
                                   focused
                                   size={size}
                                   color="primary"
                                   style={style}
                                   label="Usuario del Sistema"
                                   variant="outlined"
                                   InputLabelProps={{ shrink: true }}
                                   placeholder="Buscar usuario..."
                                   helperText="Vincular con un usuario de la aplicación"
                                 />
                               )}
                             />
              </Grid>
              {ptosVtaHiper && (
                <Grid item xs={3}>
                  <Autocomplete
                    size={size}
                    focused
                    disableClearable
                    value={datosformulario.pto_vta_hipergas}
                    noOptionsText={"Punto de Venta NO DISPONIBLE"}
                    options={ptosVtaHiper}
                    autoHighlight
                    getOptionLabel={(option) => option.id_punto}
                    onChange={(event, value) =>
                      setDatosformulario((prev) => ({
                        ...prev,
                        pto_vta_hipergas: value,
                      }))
                    }
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        key={option.id}
                        sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        {option.id_punto}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        focused
                        size={size}
                        color="primary"
                        style={style}
                        variant="outlined"
                        placeholder="Tipee para buscar..."
                        {...params}
                        label="Punto de Venta HIPERGAS"
                        inputProps={{
                          ...params.inputProps,
                        }}
                      />
                    )}
                  />
                </Grid>
              )}
              {ptosVtaAuto && (
                <Grid item xs={3}>
                  <Autocomplete
                    value={datosformulario.pto_vta_autogas}
                    size={size}
                    focused
                    disableClearable
                    noOptionsText={"Punto de Venta NO DISPONIBLE"}
                    options={ptosVtaAuto}
                    autoHighlight
                    getOptionLabel={(option) => option.id_punto}
                    onChange={(event, value) =>
                      setDatosformulario((prev) => ({
                        ...prev,
                        pto_vta_autogas: value,
                      }))
                    }
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        key={option.id}
                        sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        {option.id_punto}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        focused
                        size={size}
                        color="primary"
                        style={style}
                        variant="outlined"
                        placeholder="Tipee para buscar..."
                        {...params}
                        label="Punto de Venta AUTOGAS"
                        inputProps={{
                          ...params.inputProps,
                        }}
                      />
                    )}
                  />
                </Grid>
              )}
              <Grid item xs={6}>
                <TextField
                  size={size}
                  focused
                  placeholder="Teléfono"
                  color="primary"
                  style={style}
                  sx={sinAsterisco}
                 // type="number"
                    type="text"
                  name="telefono"
                  label="Teléfono"
                  variant="outlined"
                  value={datosformulario.telefono ?? ""}
                  onChange={almacenar}
                  inputProps={{
                    maxLength: 10,
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">{codArg}</InputAdornment>
                    ),
                  }}
                  helperText="Cód área (sin 0) + número sin el 15. Ej:341xxxxxx "
                  onKeyDown={(event) => {
                    if (!/[0-9]/.test(event.key) && event.key !== "Backspace" && event.key !== "Delete" && event.key !== "Tab") {
                      event.preventDefault();
                    }
                  }}
                />
              </Grid>

               {/* Sucursal */}
<Grid item xs={3}>
  <Autocomplete
    size={size}
    options={sucursales}
    getOptionLabel={(option) => `${option.id} - ${option.nombre}`}
    value={sucursalSeleccionada}
    onChange={(event, value) => {
      setSucursalSeleccionada(value);
      setCajaSeleccionada(null);
    }}
    isOptionEqualToValue={(option, value) => option?.id === value?.id}
    renderInput={(params) => (
      <TextField
        {...params}
        focused
        size={size}
        color="primary"
        style={style}
        label="Sucursal"
        required
        variant="outlined"
        placeholder="Buscar sucursal..."
      />
    )}
  />
</Grid>

{/* Caja Mercado Pago */}
<Grid item xs={3}>
  <Autocomplete
    size={size}
    options={cajasMercadoPago}
    loading={cargandoCajas}
    getOptionLabel={(option) => {
      if (option && typeof option === 'object') {
        return `${option.nombre || option.external_id} (ID: ${option.external_id})`;
      }
      return '';
    }}
    value={cajaSeleccionada}
    onChange={(event, value) => {
      setCajaSeleccionada(value);
    }}
    isOptionEqualToValue={(option, value) => option?.id === value?.id}
    disabled={!sucursalSeleccionada}
    renderInput={(params) => (
      <TextField
        {...params}
        focused
        size={size}
        color="primary"
        style={style}
        label="Caja Mercado Pago"
        variant="outlined"
        placeholder={sucursalSeleccionada ? "Seleccione una caja..." : "Primero seleccione una sucursal"}
      />
    )}
  />
</Grid>
{/* Terminal Point PDV */}
<Grid item xs={12}>
  <Autocomplete
    size={size}
    options={posnets || []}
    value={posnetSeleccionado}
    onChange={(event, newValue) => {
      setPosnetSeleccionado(newValue);
      
      // Validar cuando se selecciona una terminal
      if (newValue && newValue.id) {
        validarCampo("terminal", newValue.id);
      } else {
        setErrorTerminal("");
      }
    }}
    getOptionLabel={(option) => {
      if (option && typeof option === 'object') {
        const label = option.id || '';
        const posId = option.external_pos_id ? `(CAJA: ${option.external_pos_id})` : '';
        return `${label} ${posId}`.trim();
      }
      return '';
    }}
    isOptionEqualToValue={(option, value) => option?.id === value?.id}
    disabled={!sucursalSeleccionada || posnets.length === 0}
    renderInput={(params) => (
          <TextField
            {...params}
            focused
            size={size}
            style={style}
            label="Terminal Point PDV"
            placeholder={sucursalSeleccionada ? "Seleccione terminal PDV..." : "Primero seleccione una sucursal"}
            disabled={!sucursalSeleccionada || posnets.length === 0}
            error={Boolean(errorTerminal)}  // Mostrar error si existe
            helperText={
              errorTerminal || (
                posnets.length === 0 && sucursalSeleccionada 
                  ? "No hay terminales en modo PDV" 
                  : posnets.length > 0 ? `${posnets.length} terminal(es) en PDV` : ""
              )
            }
          />
        )}
        renderOption={(props, option) => (
          <li {...props}>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Typography variant="body2">
                {option.id} - CAJA: {option.external_pos_id}
              </Typography>
            </Box>
          </li>
        )}
    renderTags={(value, getTagProps) =>
      value.map((option, index) => (
        <Chip
          {...getTagProps({ index })}
          key={option.id}
          label={option.external_pos_id || option.id}
          size="small"
          color="success"
          variant="outlined"
        />
      ))
    }
  />
</Grid>
                  <Grid item xs={6}>
                                <TextField
                                  size={size}
                                  style={style}
                                  focused
                                  type="date"
                                  placeholder="Vencimiento ART"
                                  name="fecvto_art"
                                  label="Vencimiento ART"
                                  variant="outlined"
                                  value={datosformulario.fecvto_art ? moment(datosformulario.fecvto_art).format("YYYY-MM-DD") : ""}
                                  onChange={almacenar}
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        <InsertInvitationIcon />
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                              </Grid>
                              
                               <Grid item xs={6}>
                                <TextField
                                  size={size}
                                  style={style}
                                  focused
                                  type="date"
                                  placeholder="Vencimiento SVO"
                                  name="fecvto_svo"
                                  label="Vencimiento SVO"
                                  variant="outlined"
                                  value={datosformulario.fecvto_svo ? moment(datosformulario.fecvto_svo).format("YYYY-MM-DD") : ""}
                                  onChange={almacenar}
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        <InsertInvitationIcon />
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                              </Grid>
                              
                               {/* <Grid item xs={6}>
                                <TextField
                                  size={size}
                                  style={style}
                                  focused
                                  type="date"
                                  placeholder="Vencimiento Remito"
                                  name="fecvto_remito"
                                  label="Vencimiento  Remito (doc petrolera, referente a la carga)"
                                  variant="outlined"
                                  value={moment(datosformulario.fecvto_remito).format(
                                    "YYYY-MM-DD"
                                  )}
                                  onChange={almacenar}
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        <InsertInvitationIcon />
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                              </Grid>
                             
                              <Grid item xs={6}>
                                <TextField
                                  size={size}
                                  style={style}
                                  focused
                                  type="date"
                                  placeholder="Vencimiento Protocolo de calidadad"
                                  name="fecvto_protcal"
                                  label="Vencimiento Protocolo de calidadad"
                                  variant="outlined"
                                  value={moment(datosformulario.fecvto_protcal).format(
                                    "YYYY-MM-DD"
                                  )}
                                  onChange={almacenar}
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        <InsertInvitationIcon />
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                              </Grid> */}
                
                                <Grid item xs={6}>
                                <TextField
                                  size={size}
                                  style={style}
                                  focused
                                  type="date"
                                  placeholder="Vencimiento Curso de cargas peligrosa"
                                  name="fecvto_cursocp"
                                  label="Vencimiento Curso de cargas peligrosa"
                                  variant="outlined"
                                  value={datosformulario.fecvto_cursocp ? moment(datosformulario.fecvto_cursocp).format("YYYY-MM-DD") : ""}
                                  onChange={almacenar}
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        <InsertInvitationIcon />
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                              </Grid>
                               
                                 <Grid item xs={6}>
                                <TextField
                                  size={size}
                                  style={style}
                                  focused
                                  type="date"
                                  placeholder="Vencimiento Psicofisico"
                                  name="fecvto_psicof"
                                  label="Vencimiento Psicofisico"
                                  variant="outlined"
                                  value={datosformulario.fecvto_psicof ? moment(datosformulario.fecvto_psicof).format("YYYY-MM-DD") : ""}
                                  onChange={almacenar}
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        <InsertInvitationIcon />
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                              </Grid>



            </Grid>
            <Grid
              container
              justifyContent="space-between"
              alignItems="flex-end"
              mt={2}
            >
              <Button variant="contained" onClick={handleClose} color="error">
                Volver
              </Button>

              <Button
                disabled={disBtn}
                variant="contained"
                type="submit"
                color="success"
              >
                Guardar Chofer
              </Button>
            </Grid>
          </Box>
        </form>
      </Container>
      {notificacion && notificacion.open ? (
        <Notify
          mensaje={notificacion.mensaje}
          open={notificacion.open}
          color={notificacion.color}
          handleClose={() => {
            handleClose();
          }}
          severity={notificacion.severity}
          duracion={1000}
        />
      ) : null}
    </div>
  );
}

export default Editarchofer;
